// extracted by mini-css-extract-plugin
export default {"root":"CellContentArray_root__3boXX","link":"CellContentArray_link__-DsEm","placeHolderShimmer":"CellContentArray_placeHolderShimmer__WY6dP"};